import { HeroProps } from "../../HeroProps";
import Lobby from "../../lobby/Lobby";
import { baseUrl, cdnUrl, translate } from "@mediaspace/shared/utils";
import { CommonHeroLayout } from "../../layout/CommonHeroLayout";
import { Button } from "@kaltura/ds-react-components";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";

/**
 * media-page conversion status component
 */
export function ConversionStatus(props: HeroProps) {
    const { entry, categoryId, canEdit } = props;

    // edit media action
    const editAction = {
        name: "edit",
        component: Button,
        props: {
            component: "a",
            href:
                baseUrl +
                "/edit/" +
                entry.id +
                (categoryId ? "/category/" + categoryId : ""),
            children: translate("Edit details"),
            analytics: {
                action: "Media Hero - Edit converting media",
                buttonType: ButtonClickAnalyticsType.EDIT
            }
        },
    };

    // set the relevant action
    const actions = !canEdit ? [] : [editAction];

    return (
        <CommonHeroLayout>
            <Lobby
                thumbnailUrl={cdnUrl + "/media/Thumbnail.png"}
                videoUrl={cdnUrl + "/media/Thumbnail.mp4"}
                statusLabel={translate("media is processing")}
                title={entry.name}
                actions={actions}
            />
        </CommonHeroLayout>
    );
}

export default ConversionStatus;
